document.addEventListener('DOMContentLoaded', () => {
  const hiddenModalCaution = () => {
    const modal_actab = document.querySelector("div.modal-footer div.cp_actab");
    if (!modal_actab) {
      return;
    }
    modal_actab.classList.add('hidden');
  }
  
  const caution_input = document.querySelector("input#tab-caution");
  if (!caution_input) {
    hiddenModalCaution();
    return;
  }
  const caution_content = caution_input.parentNode.querySelector("div.cp_actab-content div.content-content, div.product-content-below-gallery__description__content");
  const modal_caution = document.getElementById("modal-caution-content");
  if (!caution_content || !modal_caution) {
    hiddenModalCaution();
    return;
  }

  modal_caution.innerHTML = caution_content.innerHTML;
  
});